import { TFunction } from 'i18next'
import { OccupationCategory } from 'constants/enums/occupationCategoryTypes'
import { OccupationType } from 'constants/enums/occupationTypes'
import { IOption } from 'formBuilder/src'

export const italyOccupationTypesByCategory: Record<
	OccupationCategory,
	OccupationType[]
> = {
	[OccupationCategory.PermanentEmployee]: [
		OccupationType.PublicServant,
		OccupationType.Employed,
		OccupationType.Worker,
		OccupationType.Soldier,
		OccupationType.Manager,
		OccupationType.Director,
	],
	[OccupationCategory.SelfEmployed]: [
		OccupationType.Artisan,
		OccupationType.Merchant,
		OccupationType.Entrepreneur,
		OccupationType.SalesAgent,
		OccupationType.Farmer,
		OccupationType.TruckOperator,
		OccupationType.Surveyor,
		OccupationType.SelfEmployedOther,
	],
	[OccupationCategory.IndependentProfessional]: [
		OccupationType.Doctor,
		OccupationType.Lawyer,
		OccupationType.Architect,
		OccupationType.TaxAccountant,
		OccupationType.Engineer,
		OccupationType.Notary,
	],
	[OccupationCategory.Retired]: [
		OccupationType.Retired,
		OccupationType.Pensioner,
	],
	[OccupationCategory.TemporaryEmployee]: [OccupationType.FixedTerm],
	[OccupationCategory.NoStableIncome]: [
		OccupationType.Student,
		OccupationType.VoluntaryWork,
		OccupationType.CareTaker,
		OccupationType.SeasonalWorker,
		OccupationType.Unemployed,
		OccupationType.SickLeave,
		OccupationType.Other,
	],
}

// These are the OccupationCategory values for which the employement related fields in ApplicationDetailsFormIt.tsx will be visible.
export const employedOccupationCategories: OccupationCategory[] = [
	OccupationCategory.PermanentEmployee,
	OccupationCategory.SelfEmployed,
	OccupationCategory.IndependentProfessional,
]

export function getOccupationTypeOptions(
	category: OccupationCategory | undefined,
	t: TFunction,
): IOption[] {
	if (category === undefined) return []

	return italyOccupationTypesByCategory[category].map((occupationType) => ({
		value: OccupationType[occupationType],
		label: t(OccupationType[occupationType]),
	}))
}

export function getOccupationCategoryForOccupationType(
	occupationType: OccupationType | string | null | undefined,
): OccupationCategory | undefined {
	if (occupationType === null || occupationType === undefined) return undefined

	const categoryEntry = Object.entries(italyOccupationTypesByCategory).find(
		([, occupationTypes]) =>
			occupationTypes.some(
				(o) => OccupationType[o] === String(occupationType),
			),
	)

	return categoryEntry ? (categoryEntry[0] as OccupationCategory) : undefined
}
